import { Component, OnInit } from '@angular/core';
import { Partner } from "../../../../models/partner";
import { AuthRESTService } from "../../../services/rest/auth-rest.service";
import Commons from "../../commons";
import {TranslateService} from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppWidgetModule } from 'app/components/widgets/widget.module';
import { SharedModule } from 'app/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule, AppWidgetModule],
    selector: 'app-partner-list',
    templateUrl: './partner-list.component.html',
    styleUrls: ['./partner-list.component.css']
})
export class PartnerListComponent extends Commons implements OnInit {
    partners: Array<Partner>;
    partnerToDelete: string;

    constructor(private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService) {
        super(toastr, translate)
    }

    ngOnInit(): void {
        this.rest.get('cas/configuration/partners').subscribe((res) => {
            this.partners = res;
        }, err => this.errorHandler(err));
    }

    delete(clientId: string): void {
        this.rest.delete('configuration/partners/' + clientId).subscribe((res) => {
            this.ngOnInit()
        }, err => this.errorHandler(err));
    }
}
